export const GALLERY_IMAGE_LIST_REQUEST = "GALLERY_IMAGE_LIST_REQUEST";
export const GALLERY_IMAGE_LIST_SUCCESS = "GALLERY_IMAGE_LIST_SUCCESS";
export const GALLERY_IMAGE_LIST_FAIL = "GALLERY_IMAGE_LIST_FAIL";

export const GALLERY_IMAGE_DETAILS_REQUEST = "GALLERY_IMAGE_DETAILS_REQUEST";
export const GALLERY_IMAGE_DETAILS_SUCCESS = "GALLERY_IMAGE_DETAILS_SUCCESS";
export const GALLERY_IMAGE_DETAILS_FAIL = "GALLERY_IMAGE_DETAILS_FAIL";

export const GALLERY_IMAGE_DELETE_REQUEST = "GALLERY_IMAGE_DELETE_REQUEST";
export const GALLERY_IMAGE_DELETE_SUCCESS = "GALLERY_IMAGE_DELETE_SUCCESS";
export const GALLERY_IMAGE_DELETE_FAIL = "GALLERY_IMAGE_DELETE_FAIL";

export const GALLERY_IMAGE_CREATE_REQUEST = "GALLERY_IMAGE_CREATE_REQUEST";
export const GALLERY_IMAGE_CREATE_SUCCESS = "GALLERY_IMAGE_CREATE_SUCCESS";
export const GALLERY_IMAGE_CREATE_FAIL = "GALLERY_IMAGE_CREATE_FAIL";
export const GALLERY_IMAGE_CREATE_RESET = "GALLERY_IMAGE_CREATE_RESET";

export const GALLERY_IMAGE_UPDATE_REQUEST = "GALLERY_IMAGE_UPDATE_REQUEST";
export const GALLERY_IMAGE_UPDATE_SUCCESS = "GALLERY_IMAGE_UPDATE_SUCCESS";
export const GALLERY_IMAGE_UPDATE_FAIL = "GALLERY_IMAGE_UPDATE_FAIL";
export const GALLERY_IMAGE_UPDATE_RESET = "GALLERY_IMAGE_UPDATE_RESET";

export const GALLERY_IMAGE_CREATE_REVIEW_REQUEST =
  "GALLERY_IMAGE_CREATE_REVIEW_REQUEST";
export const GALLERY_IMAGE_CREATE_REVIEW_SUCCESS =
  "GALLERY_IMAGE_CREATE_REVIEW_SUCCESS";
export const GALLERY_IMAGE_CREATE_REVIEW_FAIL =
  "GALLERY_IMAGE_CREATE_REVIEW_FAIL";
export const GALLERY_IMAGE_CREATE_REVIEW_RESET =
  "GALLERY_IMAGE_CREATE_REVIEW_RESET";

export const GALLERY_IMAGE_TOP_REQUEST = "GALLERY_IMAGE_TOP_REQUEST";
export const GALLERY_IMAGE_TOP_SUCCESS = "GALLERY_IMAGE_TOP_SUCCESS";
export const GALLERY_IMAGE_TOP_FAIL = "GALLERY_IMAGE_TOP_FAIL";
